<template>
  <li>
      <router-link :to="`/task_hall_detail?id=${itemObj.id}`"  target="_blank">
        <!-- 图片 -->
        <!-- <div class="img_box"></div> -->
        <div class="image">
          <img v-lazy="itemObj.coverPath">
        </div>
        <!-- 内容 -->
        <div class="designList_inner_box">
            <h3 class="inner_title">{{ itemObj.name }}</h3>
            <div class="inner_money">
                <span class="inner_money_left">任务酬金：</span>
                <span class="inner_money_right">￥{{ itemObj.money }}</span>
            </div>
            <div class="inner_user">
                <span><i class="iconfont">&#xe616;</i>{{ itemObj.popularity }}</span>
                <span><i class="iconfont">&#xe614;</i>{{ itemObj.collection_count }}</span>
                <span><i class="my_icon user"></i>{{ itemObj.assign_submit }}</span>
            </div>
        </div>
      </router-link>
  </li>

</template>

<script>
export default {
  props:{
    itemObj:{
      type:Object
    }
  }
}
</script>

<style lang="scss" scoped>
li:nth-child(4n){
  margin-right: 0;
}
li{
  background-color: #fff;
  border: 1px solid $bd-color;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  cursor: pointer;
  width: 285px;
  height: 358px;
  transition: all 0.3s;
  list-style: none;
  .image{
    // width: 100%;
    // height: 100%;
    overflow: hidden;
    img{
      height: 212px;
      width: 100%;
      background-color: #fff;
      object-fit: cover;
      transition: all 0.3s;
    }
  }
  .designList_inner_box{
      padding: 15px 20px;
      box-sizing: border-box;
    .inner_title{
      line-height: 32px;
      font-size:16px;
      color:rgba(51,51,51,1);
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      word-wrap:normal;
    }
    .inner_money{
      line-height: 40px;
      font-size:14px;
      color:rgba(153,153,153,1);
      .inner_money_right{
        font-size:16px;
        color:rgba(212,40,45,1);  
      }
    }
    .inner_user{
      line-height: 40px;
      font-size:12px;
      color:rgba(170,170,170,1);
      margin-top: 10px;
      span{
        margin-right: 20px;
        .my_icon{
          margin-right: 5px;
        }
      }
      span:nth-child(3){
        margin-right: 0;
      }
    }
  }
}
li:hover{
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  .image img{
    transform: scale(1.1);
  }
}
</style>
